<template>
  <div
    class="
      dropdown
      tw-hidden tw-items-center tw-text-black tw-text-right tw-w-full
      xl:tw-inline-flex
    "
    data-testid="navigation-dropdown"
  >
    <MemberAvatar
      v-if="$auth.loggedIn"
      :member="member"
      size="xxs"
      class="tw-inline-flex tw-ml-auto tw-mr-1 !tw-border-black"
    />
    <template v-if="$auth.loggedIn"
      >{{ $t('identity__welcome') }}, {{ firstName }}</template
    >
    <template v-else>{{ $t('hello_guest') }}</template>
    <ChevronDown v-if="!dropdownOpen" />
    <ChevronUp v-if="dropdownOpen" />
    <div
      class="
        dropdown-menu
        tw-absolute tw-bg-[#f8f8f8] tw-left-auto tw-py-2 tw-rounded-b
      "
    >
      <template v-if="$auth.loggedIn">
        <NuxtOrExternalLink
          v-for="(link, index) in options"
          :key="index"
          :href="link.href"
          :to="link.to"
          :class="dropdownItemClass"
        >
          {{ link.title }}
        </NuxtOrExternalLink>
      </template>

      <a
        :class="dropdownItemClass"
        data-testid="language-selector"
        @click="languageOpen = !languageOpen"
      >
        {{ $i18n.localeProperties.name }}
        <ChevronDown v-if="!languageOpen" class="tw-ml-1" />
        <ChevronUp v-if="languageOpen" class="tw-ml-1" />
      </a>
      <div
        v-if="languageOpen"
        class="tw-text-sm"
        data-testid="language-options"
      >
        <a
          v-for="locale in $i18n.locales"
          :key="locale.code"
          :data-testid="`language-option-${locale.code}`"
          class="tw-block tw-pl-5 tw-py-1 tw-text-left hover:tw-bg-gray-200"
          @click="changeLanguage(locale)"
        >
          {{ locale.name }}
        </a>
      </div>

      <a
        v-if="$auth.loggedIn"
        :class="dropdownItemClass"
        @click.prevent="$emit('signout')"
      >
        {{ $t('log_out') }}
      </a>
      <a v-if="!$auth.loggedIn" :class="dropdownItemClass" :href="loginUrl">
        {{ $t('log_in') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ChevronDown from 'vue-material-design-icons/ChevronDown'
import ChevronUp from 'vue-material-design-icons/ChevronUp'
import NuxtOrExternalLink from '@/components/shared/NuxtOrExternalLink'
import MemberAvatar from '@/components/shared/MemberAvatar.vue'

export default {
  components: {
    ChevronDown,
    ChevronUp,
    NuxtOrExternalLink,
    MemberAvatar,
  },
  data() {
    return {
      dropdownItemClass:
        'tw-flex tw-px-2.5 tw-py-1 tw-text-primary hover:tw-bg-gray-200',
      dropdownOpen: false,
      languageOpen: false,
      options: [
        {
          title: this.$t('view_profile'),
          to: this.localePath('/settings/profile'),
        },
        {
          title: this.$t('view_financials'),
          to: this.localePath('financials'),
        },
        {
          title: this.$t('navigation__settings'),
          to: this.localePath('/settings'),
        },
      ],
    }
  },
  computed: {
    ...mapState('fiiAuth', ['identity']),
    firstName() {
      return this.identity.meta ? this.identity.meta.firstName : null
    },
    avatarUrl() {
      return this.identity.meta ? this.identity.meta.avatarUrl : null
    },
    member() {
      return {
        meta: this.identity.meta,
        entityUuid: this.identity.entityUuid,
      }
    },
    loginUrl() {
      const encodedLoc = encodeURIComponent(window.location.href)
      return `${process.env.AUTH_URL}?redirect_url=${encodedLoc}`
    },
  },
  methods: {
    changeLanguage(locale) {
      this.dropdownOpen = false
      const questions = this.$store.state.surveyQuestions.questionsWithAnswers
      const question = questions.find(
        ({ code }) => code === 'language_preference'
      )
      if (question) {
        // Send to the server the language preference
        const data = {
          ...question,
          value: {
            display: locale.name,
            type: 'string',
            value: locale.code,
          },
        }

        this.$store.dispatch('surveyQuestions/save', {
          questions: [data],
          withAnswers: true,
          skipInstructions: true,
        })
      }

      if (
        this.$router.currentRoute.fullPath === `/${this.$i18n.locale}` &&
        locale.code === 'en'
      ) {
        this.$router.push('/')
      } else {
        this.$i18n.setLocale(locale.code)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown {
  display: none !important;

  @media (min-width: 1280px) {
    display: inline-flex !important;
  }

  .dropdown-menu {
    display: none;
    right: 0;
    left: inherit;
  }

  &:hover {
    .dropdown-menu {
      display: block !important;
    }
  }
}
</style>
